import { Component, OnInit, Input, Output, EventEmitter, HostListener, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@src/environments/environment'

import {
  CardPreviewService,
  IMediaBackground,
  IShowModal,
  IWeblinkIcons,
  iconsWeblink,
  IBrandcard,
  ISocialMediaArray,
  ISocialMedia,
  IBrandcardResult,
  EnumIcons
} from '@app/components/card-preview'

// import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Component({
  selector: 'app-frame-icons',
  templateUrl: './frame-icons.component.html',
  styleUrls: ['./frame-icons.component.scss']
})
export class FrameIconsComponent implements OnInit {
  @Input() mediaData: IBrandcardResult
  @Input() currentStep: number
  @Input() barColor: string
  @Output() iconActionSender = new EventEmitter<string>();

  isShowAllIcons = true
  isShowFooterOnProfile = false
  isShowActionTextIcons = false
  isShowActionSocialLinkIcons = false
  footerIconColumn = 0
  socialIconColumn: string
  isSocialIconNot5or7Above = true
  // deviceInfo: DeviceInfo
  weblinkIcons: IWeblinkIcons = iconsWeblink
  user_mobile: string
  user_email: string
  innerWidth: number
  isShowToast = false
  toastMessage: string

  constructor(
    private brandcardService: CardPreviewService,
    // private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.footerActionDynamic()
    this.iconSocialLinkDynamic()
    this.listenCurrentSubscriber()
    this.attachSocialLinkIcons()
    // this.getDeviceInfo()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = this.brandcardService.getWindow().innerWidth;
    }
  }

  // getDeviceInfo() {
  //   this.deviceInfo = this.deviceService.getDeviceInfo()
  // }

  listenCurrentSubscriber() {
    this.brandcardService.currentStatusDisplayAllIcons.subscribe((status: boolean) => {
      this.isShowAllIcons = status
    })

    this.brandcardService.currentFooterToVisible.subscribe((status: boolean) => {
      this.isShowFooterOnProfile = status
    })

    this.brandcardService.currentShowMessageIcons.subscribe((status: boolean) => {
      this.isShowActionTextIcons = status
    })

    this.brandcardService.currentShowSocialLinkIcons.subscribe((status: boolean) => {
      this.isShowActionSocialLinkIcons = status
    })

    this.user_mobile = this.mediaData.mobile
    this.user_email = this.mediaData.email
  }

  attachSocialLinkIcons() {
    this.mediaData.socials = this.mediaData.socials.map((social: ISocialMediaArray) => {
      if (social.label === 'facebook') {
        return {
          ...social,
          icon: this.weblinkIcons.facebook
        }
      }
      if (social.label === 'vimeo') {
        return {
          ...social,
          icon: this.weblinkIcons.vimeo
        }
      }
      if (social.label === 'twitter') {
        return {
          ...social,
          icon: this.weblinkIcons.x
        }
      }
      if (social.label === 'instagram') {
        return {
          ...social,
          icon: this.weblinkIcons.instagram
        }
      }
      if (social.label === 'linkedin') {
        return {
          ...social,
          icon: this.weblinkIcons.linkedin
        }
      }
      if (social.label === 'youtube') {
        return {
          ...social,
          icon: this.weblinkIcons.youtube
        }
      }
    })
  }

  iconAction(action: string) {
    if (this.currentStep !== 7)
      return

    this.brandcardService.setShowSocialLinkIcons(false)
    this.brandcardService.setShowMessageIcons(false)
    this.brandcardService.setStatusDisplayAllIcons(false)
    this.brandcardService.setProfileLogoToBottom(false)
    this.brandcardService.setProfileLogoToTop(false)
    if (action === EnumIcons.Featured_Content) {
      this.sendIconAction(action)
      this.brandcardService.setScreen2(true)
    }
    if (action === EnumIcons.Text && this.mediaData.is_public) {
      this.sendIconAction(action)
      this.brandcardService.setShowMessageIcons(true)
      this.brandcardService.setProfileLogoToBottom(true)
      this.brandcardService.setScreen2(true)
    }
    if ((action === EnumIcons.Text || action === EnumIcons.Call || action === EnumIcons.Email) && !this.mediaData.is_public) {
      this.brandcardService.setShowModal({display: true, which_text: 'private'})
      this.brandcardService.setStatusDisplayAllIcons(true)
      this.brandcardService.setProfileLogoToTop(true)
      this.TriggerMessageToast('Private')
      return
    }
    if (action === EnumIcons.Social_Link) {
      if (!this.mediaData.socials.length) {
        this.brandcardService.setStatusDisplayAllIcons(true)
        this.brandcardService.setProfileLogoToTop(true)
        this.TriggerMessageToast('Social')
        return
      }
      this.sendIconAction(action)
      this.brandcardService.setShowSocialLinkIcons(true)
      this.brandcardService.setScreen2(true)
      this.brandcardService.setProfileLogoToBottom(true)
    }
    if (action === EnumIcons.Profile) {
      this.sendIconAction(action)
      this.brandcardService.setFooterToVisible(true)
      this.brandcardService.setScreen2(true)
    }
  }

  sendIconAction(action: string) {
    this.iconActionSender.emit(action)
  }

  TriggerMessageToast(msg: string) {
    this.isShowToast = true
    this.toastMessage = `No ${msg} links provided`

    if (msg.toLowerCase() === 'location' || msg.toLowerCase() === 'website') {
      this.toastMessage = `No ${msg} link provided`
    }
    if (msg.toLowerCase() === 'feature ccontent') {
      this.toastMessage = `No ${msg} provided`
    }
    if (msg.toLowerCase() === 'private') {
      this.toastMessage = `${msg} Brand Card`
    }

    setTimeout(() => {
      this.isShowToast = false
    }, 2000);
  }

  openMedia(url: string, icon?: string) {
    if (this.currentStep !== 7)
      return

    if (url === 'whatsapp') {
      const mobile = this.mediaData.mobile
      url = `https://api.whatsapp.com/send?phone=${mobile}&text=`
    }
    if (url === 'zbuzz') {
      this.brandcardService.setShowModal({display: true, which_text: 'zbuzz'})
      return
    }
    if (url === 'postcard') {
      this.brandcardService.setShowModal({display: true, which_text: 'postcard'})
      return
    }
    if (url === 'download') {
      url = `${environment.zerobrandcardUrl}#Environment`
    }
    if (url === 'playstore') {
      url = 'https://play.google.com/store/apps/details?id=tech.zero.app2&referrer=utm_source%3Dweblink%26utm_medium%3Derrorpage%26utm_campaign%3Dtrackinstall'
    }

    if (url !== '') {
      if (isPlatformBrowser(this.platformId)) {
        this.brandcardService.getWindow().open(url, '_blank')
        return
      }
    }

    this.TriggerMessageToast(icon)
  }

  footerActionDynamic() {
    if (this.mediaData.custom_links && this.mediaData.custom_links.length === 1) {
      this.footerIconColumn =  12
    } else if (this.mediaData.custom_links && this.mediaData.custom_links.length === 2) {
      this.footerIconColumn =  6
    } else if (this.mediaData.custom_links && this.mediaData.custom_links.length === 3) {
      this.footerIconColumn =  4
    } else if (this.mediaData.custom_links && this.mediaData.custom_links.length === 4) {
      this.footerIconColumn =  3
    }
  }

  iconSocialLinkDynamic() {
    if (this.mediaData.socials) {
      if (this.mediaData.socials.length === 1) {
        this.socialIconColumn = `col-${12}`
      } else if (this.mediaData.socials.length === 2) {
        this.socialIconColumn = `col-${6}`
      } else if (this.mediaData.socials.length === 3) {
        this.socialIconColumn = `col-${4}`
      } else if (this.mediaData.socials.length === 4) {
        this.socialIconColumn = `col-${3}`
      } else if (this.mediaData.socials.length === 5) {
        this.isSocialIconNot5or7Above = false
      } else if (this.mediaData.socials.length === 6) {
        this.socialIconColumn = `col-${1}`
      } else {
        this.isSocialIconNot5or7Above = false
      }
    }
  }

  footerActionOpen(url: string) {
    if (this.currentStep === 4)
      return

    if (isPlatformBrowser(this.platformId)) {
      this.brandcardService.getWindow().open(url, '_blank')
    }
  }

  get defineBgColorBarBottom() {
    return this.brandcardService.lightOrDark(this.mediaData.color.bar.bottom)
  }

}
